import { Link } from 'react-router-dom';
import { gruender } from '../../../mocks/ueber-uns';

export default function GruenderSpotlight() {
  return (
    <section className="py-20 sm:py-24 bg-[#e9e4dc]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center max-w-xl mx-auto mb-14">
          <span className="inline-block text-xs font-semibold tracking-widest text-[#0D2B4E]/75 uppercase mb-3">
            Unser Gründer
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0D2B4E] mb-4">
            Ein Mensch, eine Vision
          </h2>
          <p className="text-gray-600 text-base leading-relaxed">
            IGM Facility Service ist kein Zufallsprodukt — sondern das Ergebnis
            jahrelanger Erfahrung und dem Mut, etwas Eigenes aufzubauen.
          </p>
        </div>

        {/* Main Feature Card */}
        <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
          <div className="flex flex-col lg:flex-row">

            {/* Photo Column */}
            <div className="relative lg:w-2/5 flex-shrink-0">
              <div className="w-full h-72 sm:h-96 lg:h-full min-h-[480px]">
                <img
                  src={gruender.image}
                  alt={gruender.name}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0D2B4E]/80 via-[#0D2B4E]/20 to-transparent lg:bg-gradient-to-r lg:from-transparent lg:via-transparent lg:to-[#0D2B4E]/10" />
              </div>
              {/* Name Overlay on photo */}
              <div className="absolute bottom-0 left-0 right-0 p-7 lg:hidden">
                <p className="text-white font-bold text-2xl">{gruender.name}</p>
                <p className="text-white/75 text-sm mt-1">{gruender.role}</p>
              </div>
              {/* Tagline badge */}
              <div className="absolute top-5 left-5">
                <span className="bg-[#C8860A] text-white text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wide">
                  {gruender.tagline}
                </span>
              </div>
            </div>

            {/* Content Column */}
            <div className="flex-1 p-8 sm:p-10 lg:p-12 flex flex-col justify-between gap-8">

              {/* Name + Role (desktop) */}
              <div className="hidden lg:block">
                <h3 className="text-3xl font-bold text-[#0D2B4E]">{gruender.name}</h3>
                <p className="text-[#C8860A] font-semibold mt-1">{gruender.role}</p>
              </div>

              {/* Quote */}
              <blockquote className="relative border-l-4 border-[#C8860A] pl-6">
                <div className="w-7 h-7 flex items-center justify-center mb-3">
                  <i className="ri-double-quotes-l text-[#C8860A] text-2xl" />
                </div>
                <p className="text-[#0D2B4E] text-base sm:text-lg font-medium leading-relaxed italic">
                  {gruender.quote}
                </p>
                <footer className="mt-3 text-sm text-gray-500 font-medium">— {gruender.name}</footer>
              </blockquote>

              {/* Bio + Motivation */}
              <div className="space-y-4">
                <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                  {gruender.bio}
                </p>
                <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                  {gruender.motivation}
                </p>
              </div>

              {/* Skills */}
              <div>
                <p className="text-xs font-bold tracking-widest text-[#0D2B4E]/65 uppercase mb-3">Fachgebiete</p>
                <div className="flex flex-wrap gap-2">
                  {gruender.skills.map((skill) => (
                    <span
                      key={skill}
                      className="text-xs font-medium bg-[#0D2B4E]/10 text-[#0D2B4E] px-3 py-1.5 rounded-full border border-[#0D2B4E]/10"
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </div>

              {/* Contact */}
              <div className="flex flex-wrap gap-3 pt-2 border-t border-gray-200">
                <a
                  href={`tel:${gruender.phone}`}
                  className="inline-flex items-center gap-2 bg-[#0D2B4E] text-white px-5 py-2.5 rounded-lg text-sm font-semibold hover:bg-[#0D2B4E]/90 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-phone-line" />
                  </div>
                  {gruender.phone}
                </a>
                <a
                  href="/kontakt"
                  className="inline-flex items-center gap-2 border border-[#0D2B4E]/35 text-[#0D2B4E] px-5 py-2.5 rounded-lg text-sm font-semibold hover:bg-[#0D2B4E]/8 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-mail-line" />
                  </div>
                  Nachricht schreiben
                </a>
              </div>
            </div>
          </div>

          {/* Career Timeline Strip */}
          <div className="border-t border-gray-200 bg-[#0D2B4E] px-8 sm:px-10 lg:px-12 py-7">
            <p className="text-xs font-bold tracking-widest text-white/65 uppercase mb-5">Karrierestationen</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {gruender.career.map((step, i) => (
                <div key={i} className="flex gap-4 items-start">
                  <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-white/15 mt-0.5">
                    <span className="text-[#C8860A] text-xs font-black">{i + 1}</span>
                  </div>
                  <div>
                    <p className="text-white/70 text-xs font-semibold mb-0.5">{step.year}</p>
                    <p className="text-white text-sm font-bold mb-1">{step.label}</p>
                    <p className="text-white/75 text-xs leading-relaxed">{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
